module.exports = __webpack_public_path__ + "static/media/logo.37899e3f.png";